import { layout } from '../../../App.routing'

function getLayout(orientation?: 'vertical' | 'horizontal') {
    if (orientation === 'vertical') {
        return layout.component({
            type: 'juliet',
            props: {
                cardType: {
                    type: 'landscape',
                    format: 'landscape-noTeaserNoKicker',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['politics/election-fact-checker'],
                    paging: {
                        page: 1,
                        pageSize: 4,
                        pageOffset: 0,
                    },
                },
            },
        })
    }

    return layout.component({
        type: 'lima',
        props: {
            hasBorder: false,
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['politics/election-fact-checker'],
                paging: {
                    page: 1,
                    pageSize: 4,
                    pageOffset: 0,
                },
            },
        },
    })
}

export const factCheckerSegment = (options: {
    orientation?: 'vertical' | 'horizontal'
}) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'federal-election-2022-fact-checker',
        props: {
            verticalSpacing: 'xl',
            containerWidth: '100%',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'fact-checker-section-header',
                    props: {
                        sizing: 'smaller',
                        dataDefinitionArgs: {
                            type: 'listing',
                            topics: ['politics/federal-election'],
                            authors: ['john-flint'],
                            paging: {
                                page: 1,
                                pageSize: 1,
                                pageOffset: 0,
                            },
                        },
                    },
                }),
                getLayout(options.orientation),
            ],
        },
    })
}
